var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"info-unit"},[_c('p',[_vm._v(_vm._s(_vm.titleKey)+"：")]),_c('div',{staticClass:"info-unit-right"},[_c('p',[_vm._v(_vm._s(_vm.titleValue))]),_c('ul',{staticClass:"info-unit-right-value"},_vm._l((_vm.infoArray),function(item,index){return _c('li',{key:index},[_vm._v(" "+_vm._s(item)+" ")])}),0)])])
}
var staticRenderFns = []

export { render, staticRenderFns }